<template> 
    <main-block v-if="simulations">  
        <main-title>History</main-title>

        <!-- HISTORY FILTERS START -->
        <history-filters/>
        <!-- HISTORY FILTERS END -->    
 
        <!-- HISTORY ITEMS START -->
        <template v-if="simulations.length != 0">
            <history-list 
                :simulations="simulations"
            /> 
        </template> 
        <template v-else>
            <router-link class="main-btn" to='/'>Create a first one</router-link>
        </template>
        <!-- HISTORY ITEMS END -->
    </main-block> 
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import historyFilters from '@/components/filters/history/FilterItem';
import historyList from '@/components/lists/history/ListItem';
// import mainBlock from '../../components/layout/mainBlock';

export default {
    name: 'history',
    components: {
        historyFilters,
        historyList
    },
    data() {
        return {
            form: {},
            options: [
                {
                    value: 'Service 1',
                    label: 'Service 1'
                },
                {
                    value: 'Service 2',
                    label: 'Service 2'
                },
                {
                    value: 'Service 3',
                    label: 'Service 3'
                }
            ],
            services: [
                {
                    value: 'All',
                    label: 'All'
                },
                {
                    value: 'Service 1',
                    label: 'Service 1'
                },
                {
                    value: 'Service 2',
                    label: 'Service 2'
                },
                {
                    value: 'Service 3',
                    label: 'Service 3'
                }
            ],
            service: '',
            value: ''
        }
    },
    computed: {
        ...mapGetters({
            simulations: 'simulation/simulations'
        }),
    }, 
    methods: {
        ...mapMutations({
            clearSimulations: 'simulation/clearSimulations'
        }),
        ...mapActions({ 
            get: 'simulation/get'
        })
    },
    async mounted() {   
      await this.get();  
    },
    beforeDestroy() {
        this.clearSimulations();
    }
} 
</script> 

<style lang="scss"> 
.history-box {
    height: 95vh; 
    overflow-y: auto;
    background-color: #fff;
    padding: 20px; 
} 
</style>